import React, { useEffect, useState } from 'react'
import { publicRequest } from '../publicRequest';
import Loadingspinner from './Loadingspinner';

const Table = (props) => {

    const { numberDate, datetime } = props;
    let dateArray = [];
    for (let i = 1; i <= numberDate; i++) {
        dateArray.push(i)
    }

    const [fetchdata, setFetchdata] = useState([])
    const [isloading, setLoading] = useState()

    const cutDecimal = (x) => {
        let decimal = Number.parseFloat(x).toFixed(1);
        var newdecimal = decimal.replace(".0", "");
        return newdecimal;
    }

    useEffect(() => {
        const getData = async () => {
            setLoading(true)
            try {
                const res = await publicRequest.get("test?input=" + datetime)
                console.log(res)
                if (res.status === 200) {
                    setFetchdata(res.data)
                    setLoading(false)
                } else {
                    setLoading(true)
                }
            } catch {
                console.error();
                setLoading(true)
            }
        };
        getData();

    }, [datetime])

    const reanderTabale = (
        <div className="table-responsive">
            <table className="table table-responsive table-bordered text-center">
                <thead>
                    <tr>
                        <th rowspan="2" style={{ textAlign: "center", paddingLeft: "50px", paddingRight: "50px" }}>
                            Services
                        </th>
                        <th colSpan={numberDate}>สถานะระบบ (วันที่)</th>
                    </tr>
                    <tr>
                        {
                            dateArray.map((val, key) => {
                                return (
                                    <th style={{minWidth:"50px", width:"50px"}} key={key}>{val}</th>
                                   )
                                 })
                        }
                    </tr>
                </thead>
                <tbody className="table-group-divider">
                    {
                        fetchdata.map((val, key) => {
                            return (
                                <tr>
                                    <td key={key} style={{ textAlign: "center" }}>{val.ServiceName}</td>
                                    {
                                        val.UpTime.map((upval, upvalkey) => {
                                            let textStyles = "";
                                            if (upval >= 98.5) {
                                                textStyles = "text-success"
                                            } else if (upval >= 90) {
                                                textStyles = "text-warning"
                                            } else if (upval < 90) {
                                                textStyles = "text-danger"
                                            }
                                            return (
                                                <td className={textStyles} style={{minWidth:"50px", width:"50px", textAlign: "center" }} key={upvalkey}>{cutDecimal(upval)}%</td>
                                            )
                                        })
                                    }
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );

    return (
        <div>
            {
                isloading ? <Loadingspinner /> : reanderTabale
            }
        </div>

    )
}

export default Table